<template>
  <main>
   <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
    <section-article id="scrollToOnLoad"
      v-if="mainArticle.id" :article="mainArticle"></section-article>
    <section-article
      v-for="(article, i) in articles" :key="i" :article="article" :isStatic="true" :index="i">
   </section-article>
   <section-support></section-support>
  </main>
</template>

<script>
import article from '@/api/v1/article';
import Hero from '@/components/Hero';
import Support from '@/components/Support/Index';
import Article from '@/components/Article';

export default {
  data() {
    return {
      isExtended: true,
      bgImg: 'Banner1-I_Love_Science-',
      subtitle: this.$t('nav.iLoveScience'),
      mainArticle: {},
      articles:
      [
        {
          photo: 'img-1.jpg',
          title: this.$t('furtherScientific.articles_title_1'),
          header: this.$t('furtherScientific.articles_header_1'),
          btn: this.$t('linkToWebsite'),
          link: 'https://www.berufsberatung.ch/dyn/show/1893?Txt=chemie&lang=de&Idx=30&postBack=true&SortLastTitle=47946B6286B778D12A23A9755822C155ECF0B009&CountResult=10&Total_Idx=10&CounterSearch=2&UrlAjaxWebSearch=%2FFunktionWeb%2FAjaxWebSearch&preFilter=&Sort=id_educationaltype',
        },
        {
          photo: 'img-2.jpg',
          title: this.$t('furtherScientific.articles_title_2'),
          header: this.$t('furtherScientific.articles_header_2'),
          btn: this.$t('linkToWebsite'),
          link: 'https://berufskunde.com/index.html',
        },
        {
          photo: 'img-3.jpg',
          title: this.$t('furtherScientific.articles_title_3'),
          header: this.$t('furtherScientific.articles_header_3'),
          btn: this.$t('linkToWebsite'),
          link: 'https://www.nationalerzukunftstag.ch/de/home/',
        },
      ],
    };
  },
  components: {
    'section-hero': Hero,
    'section-article': Article,
    'section-support': Support,
  },
  methods: {
    getArticle() {
      const succ = (response) => {
        this.mainArticle = response.data.article;
      };
      article.index(succ, this.$route.params.articleId);
    },
  },
  created() {
    this.getArticle();
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/helpers/_variables.scss";

.science {
  padding: 155px 195px 156px 195px;
  background-color: #e4e4e4;
  margin-bottom: 150px;
  &__title {
    color: $color--gray-3;
    text-align: center;
    line-height: 72px;
    padding-bottom: 70px;
  }
}
.button {
  &__xl {
    width: 100%;
    padding: 23px 0;
    line-height: 20px;
    border-radius: 35px;
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ILoveScience.vue